import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule, NgSelectModule],
  entryComponents: [],
  declarations: [SidebarComponent],
  exports: [SidebarComponent],
})
export class ComponentsModule {}
